module.exports = {
  "country": "EE",
  "artist": "Getter Jaani",
  "song": "Rockefeller Street",
  "year": "2011",
  "place": "24",
  "spotify": "4rvFyA7h88s8DehCOjqW9K"
};